import { User } from '../../../../common/src/model.ts';
import { LocalStorageKey } from '../../data/client_local_storage.ts';
import { useHousehold } from '../../data/use_household.tsx';
import { useLocalStorage } from '../../data/use_local_storage.tsx';
import { EditUser } from '../onboarding/edit_user.tsx';
import { DialogPage } from '../settings/dialog_page.tsx';
import { reopenProfileDrawerAfterNavigation } from './profile_drawer_state.ts';

// Full-screen Add Household Member dialog launched from the profile drawer's Add slot (#3356).
// Both back and Continue slide out to the previous page and reopen the drawer - a deliberate
// exception to the "navigation closes the drawer" rule so the member row stays in view.
// Continue also makes the new member the active user so the drawer shows them highlighted.
export const AddMemberPage = () => {
  const { household, setHousehold } = useHousehold();
  const [, setActiveUserToken] = useLocalStorage(LocalStorageKey.ActiveUserToken);

  return (
    <DialogPage title="Add Household Member" onExit={reopenProfileDrawerAfterNavigation}>
      {(requestBack) => (
        <EditUser
          onDone={(newMember?: User) => {
            if (newMember) {
              setActiveUserToken(newMember.token);
            }
            requestBack();
          }}
          household={household}
          setHousehold={setHousehold}
          isVisible={true}
          embed={true}
        />
      )}
    </DialogPage>
  );
};
